import { FC, useLayoutEffect, useRef, useState } from "react";
import Button from "~/components/Button";
import { Product } from "~/services/product";
import styles from "./ProductDescription.module.scss";

interface ProductDescriptionProps {
  product: Product;
}

const ProductDescription: FC<ProductDescriptionProps> = ({ product }) => {
  const shortRef: any = useRef(null);
  const [viewMore, setViewMore] = useState(true);
  const [isShowMore, setIsShowMore] = useState(false);

  useLayoutEffect(() => {
    if (document) {
      const elem: any = document.getElementById("product-description");
      if (elem?.clientHeight > shortRef?.current?.offsetHeight) {
        setViewMore(true);
      }
    }
  }, []);

  if (!product?.description?.html) return null;

  return (
    <div className="flex flex-col gap-5">
      <div
        ref={shortRef}
        className={`${styles.ProductDescription} ${
          isShowMore ? styles.showMore : ""
        } ps-desc`}
      >
        {!isShowMore && <div className={styles.expanderContentFade}></div>}
        <div
          className={styles.expanderContent}
          id="product-description"
          dangerouslySetInnerHTML={{ __html: product?.description?.html || "" }}
        />
      </div>
      {viewMore && (
        <div
          onClick={() => setIsShowMore(!isShowMore)}
          className={styles.viewMore}
        >
          {
            <i
              className={`fa ${
                isShowMore ? "fa-chevron-up" : "fa-chevron-down"
              }`}
            />
          }
          &nbsp;
          <Button type="borderless">
            {" "}
            {isShowMore ? "Read Less" : "Read More"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProductDescription;
